import useAxiosHook, { configure, Options, } from 'axios-hooks'
import {AxiosRequestConfig} from 'axios'
import { MILESPAY_API } from '../services'
import { useMemo } from 'react'

configure({ axios: MILESPAY_API, defaultOptions: {
    autoCancel: false
  }})
  
export const useMilespayAPI = (params: string | AxiosRequestConfig, options?: Options) => { 
    const config: AxiosRequestConfig = useMemo(() => {
        let newConfig: AxiosRequestConfig = {}

        if (typeof params === "string") {
            newConfig.url = params
        } else {
            newConfig = {
                ...params,
            }
        }

        return {
            ...newConfig
        }
    }, [params])

    return useAxiosHook(config, options)
}